import { render, staticRenderFns } from "./ModalESObjeto.vue?vue&type=template&id=57789875&scoped=true&"
import script from "./ModalESObjeto.vue?vue&type=script&lang=js&"
export * from "./ModalESObjeto.vue?vue&type=script&lang=js&"
import style0 from "./ModalESObjeto.vue?vue&type=style&index=0&id=57789875&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57789875",
  null
  
)

export default component.exports